import React from "react";

const TIER_META = {
  basic: {
    bg: "var(--color-bg-subtle)",
    color: "var(--color-text-muted)",
    border: "var(--color-border)",
  },
  premium: {
    bg: "var(--color-primary-light)",
    color: "var(--color-primary)",
    border: "var(--color-primary-border)",
  },
  enterprise: {
    bg: "var(--color-warning-bg)",
    color: "var(--color-warning)",
    border: "var(--color-warning-border)",
  },
};

export default function UserProfileButton({ auth, userTier, onProfileClick }) {
  const key = String(userTier || "").toLowerCase();
  const meta = TIER_META[key] || TIER_META.basic;
  const initials = auth?.username ? auth.username.slice(0, 2).toUpperCase() : "?";

  return (
    <button
      onClick={onProfileClick}
      style={{
        width: "44px",
        height: "44px",
        borderRadius: "50%",
        backgroundColor: meta.bg,
        border: `2px solid ${meta.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "15px",
        fontWeight: "var(--font-semibold)",
        color: meta.color,
        cursor: "pointer",
        padding: 0,
        fontFamily: "inherit",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "scale(1.08)";
        e.target.style.boxShadow = `0 0 0 3px ${meta.bg}80`;
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow = "none";
      }}
      title="Profil"
    >
      {initials}
    </button>
  );
}
